import React from "react";
import {Link} from "react-router-dom";

function Breadcrumbs(props) {
  return (
    <Link to={props.url} className={"stage-breadcrumb mb-3"} style={{color:props.color}}>{props.title}</Link>
  );
}
export default Breadcrumbs;
